// RFC 7807 Problem Details (P5 §5.1).
import { z } from 'zod';
import { ErrorCode } from './codes.js';
export const Problem = z.object({
    type: z.string().url(),
    title: z.string(),
    status: z.number().int().min(400).max(599),
    code: z.nativeEnum(ErrorCode),
    detail: z.string().optional(),
    instance: z.string().optional(),
    trace_id: z.string().optional(),
    /** Metadata estructurada específica del code. */
    meta: z.record(z.unknown()).optional(),
});
const PROBLEM_TYPE_BASE = 'https://api.marzano.cl/errors/';
function codeToTypeSlug(code) {
    return code.toLowerCase().replace(/_/g, '-');
}
export function buildProblem(input) {
    return {
        type: `${PROBLEM_TYPE_BASE}${codeToTypeSlug(input.code)}`,
        title: input.title,
        status: input.status,
        code: input.code,
        ...(input.detail !== undefined && { detail: input.detail }),
        ...(input.instance !== undefined && { instance: input.instance }),
        ...(input.trace_id !== undefined && { trace_id: input.trace_id }),
        ...(input.meta !== undefined && { meta: input.meta }),
    };
}
//# sourceMappingURL=problem.js.map